import React, { useState, useEffect } from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import Tooltip from "@material-ui/core/Tooltip";
import {
  CardContent,
  CardMedia,
  Typography,
  IconButton,
} from "@material-ui/core";
import ShareIcon from "@material-ui/icons/Share";
import WhatHotGridWrapper from "./styles/WhatsHotGrid.style";

function HotCollectionGrid(props) {
  const { publisher, onClickShareCollection, onClickCollectionCard } = props;
  const { homepage } = publisher;

  const [hotCollections, setHotCollections] = useState([]);

  useEffect(() => {
    setHotCollections([
      homepage.collections.collection1,
      homepage.collections.collection2,
      homepage.collections.collection3,
    ]);
  }, [props.publisher]);

  return hotCollections.map((item, index) => (
    <WhatHotGridWrapper
      className="hotCollection hot-collection-root" 
      key={String(index)} 
      onClick={(event) => onClickCollectionCard(event, `/licensing${item.cta}`)}
    >
      <div className="whats-hot-card-container">
        <CardMedia
          className="collection-image"
          image={item.videos.length > 0 ? item.videos[0].imgUrl : "/"}
        />
        <CardContent>
          <div className="whats-hot-details">
            {item.title.length > 38 ? (
              <Tooltip title={item.title}>
                <span className="collection-title">
                  {item.title.slice(0, 38)}...
                </span>
              </Tooltip>
            ) : (
              <span className="collection-title">
                {item.title}
              </span>
            )}
           
          </div>
          
          <div className="hotCollection__description">
            <Typography variant="body2" color="textSecondary" component="p" className="hot-description">
              {item.description}
              <Tooltip title="Copy link">
                <CopyToClipboard text={`${process.env.REACT_APP_FUNK_URL}/licensing${item.cta}`} className="collection-list-share-btn">
                  
                  <IconButton onClick={onClickShareCollection}>
                    <ShareIcon />
                  </IconButton>
                  
                </CopyToClipboard>
              </Tooltip>
            </Typography>
          </div>
        </CardContent>
      </div>
    </WhatHotGridWrapper>
  ));
}

export default HotCollectionGrid;
